export const currencies = [
  { label: "🇦🇪 United Arab Emirates – Dirham", value: "AED" },
  { label: "🇦🇫 Afghanistan – Afghani", value: "AFN" },
  { label: "🇦🇱 Albania – Lek", value: "ALL" },
  { label: "🇦🇲 Armenia – Dram", value: "AMD" },
  { label: "🇦🇷 Argentina – Peso", value: "ARS" },
  { label: "🇦🇺 Australia – Dollar", value: "AUD" },
  { label: "🇦🇿 Azerbaijan – Manat", value: "AZN" },

  { label: "🇧🇩 Bangladesh – Taka", value: "BDT" },
  { label: "🇧🇬 Bulgaria – Lev", value: "BGN" },
  { label: "🇧🇭 Bahrain – Dinar", value: "BHD" },
  { label: "🇧🇷 Brazil – Real", value: "BRL" },
  { label: "🇧🇹 Bhutan – Ngultrum", value: "BTN" },

  { label: "🇨🇦 Canada – Dollar", value: "CAD" },
  { label: "🇨🇭 Switzerland – Franc", value: "CHF" },
  { label: "🇨🇱 Chile – Peso", value: "CLP" },
  { label: "🇨🇳 China – Yuan", value: "CNY" },
  { label: "🇨🇴 Colombia – Peso", value: "COP" },
  { label: "🇨🇿 Czech Republic – Koruna", value: "CZK" },

  { label: "🇩🇪 Germany – Euro", value: "EUR" },
  { label: "🇩🇰 Denmark – Krone", value: "DKK" },

  { label: "🇪🇬 Egypt – Pound", value: "EGP" },
  { label: "🇪🇸 Spain – Euro", value: "EUR" },
  { label: "🇪🇺 European Union – Euro", value: "EUR" },

  { label: "🇬🇧 United Kingdom – Pound Sterling", value: "GBP" },
  { label: "🇬🇪 Georgia – Lari", value: "GEL" },

  { label: "🇭🇰 Hong Kong – Dollar", value: "HKD" },
  { label: "🇭🇺 Hungary – Forint", value: "HUF" },

  { label: "🇮🇩 Indonesia – Rupiah", value: "IDR" },
  { label: "🇮🇱 Israel – New Shekel", value: "ILS" },
  { label: "🇮🇳 India – Rupee", value: "INR" },
  { label: "🇮🇶 Iraq – Dinar", value: "IQD" },
  { label: "🇮🇷 Iran – Rial", value: "IRR" },

  { label: "🇯🇵 Japan – Yen", value: "JPY" },

  { label: "🇰🇪 Kenya – Shilling", value: "KES" },
  { label: "🇰🇷 South Korea – Won", value: "KRW" },
  { label: "🇰🇼 Kuwait – Dinar", value: "KWD" },

  { label: "🇱🇰 Sri Lanka – Rupee", value: "LKR" },

  { label: "🇲🇽 Mexico – Peso", value: "MXN" },
  { label: "🇲🇾 Malaysia – Ringgit", value: "MYR" },

  { label: "🇳🇬 Nigeria – Naira", value: "NGN" },
  { label: "🇳🇵 Nepal – Rupee", value: "NPR" },
  { label: "🇳🇿 New Zealand – Dollar", value: "NZD" },

  { label: "🇴🇲 Oman – Rial", value: "OMR" },

  { label: "🇵🇭 Philippines – Peso", value: "PHP" },
  { label: "🇵🇰 Pakistan – Rupee", value: "PKR" },
  { label: "🇵🇱 Poland – Zloty", value: "PLN" },

  { label: "🇶🇦 Qatar – Riyal", value: "QAR" },

  { label: "🇷🇴 Romania – Leu", value: "RON" },
  { label: "🇷🇺 Russia – Ruble", value: "RUB" },

  { label: "🇸🇦 Saudi Arabia – Riyal", value: "SAR" },
  { label: "🇸🇪 Sweden – Krona", value: "SEK" },
  { label: "🇸🇬 Singapore – Dollar", value: "SGD" },
  { label: "🇹🇭 Thailand – Baht", value: "THB" },
  { label: "🇹🇷 Turkey – Lira", value: "TRY" },

  { label: "🇺🇦 Ukraine – Hryvnia", value: "UAH" },
  { label: "🇺🇸 United States – Dollar", value: "USD" },
  { label: "🇺🇾 Uruguay – Peso", value: "UYU" },

  { label: "🇻🇳 Vietnam – Dong", value: "VND" },

  { label: "🇿🇦 South Africa – Rand", value: "ZAR" },
];

// Helper function to get unique currencies (removes duplicates like EUR)
export const getUniqueCurrencies = () => {
  const seen = new Set();
  return currencies.filter((currency) => {
    if (seen.has(currency.value)) {
      return false;
    }
    seen.add(currency.value);
    return true;
  });
};

// Helper function to extract flag emoji from label
export const getCurrencyFlag = (label) => {
  return label.split(" ")[0];
};

// Helper function to get short label (flag + code)
export const getCurrencyShortLabel = (currency) => {
  const flag = getCurrencyFlag(currency.label);
  return `${flag} ${currency.value}`;
};

// Currency data with exchange rates and tax information for CurrencyContext
export const currencyData = [
  { code: "AED", symbol: "د.إ", name: "UAE Dirham", flag: "🇦🇪", exchangeRate: 0.044, taxRate: 5 },
  { code: "AFN", symbol: "؋", name: "Afghan Afghani", flag: "🇦🇫", exchangeRate: 0.85, taxRate: 0 },
  { code: "ALL", symbol: "L", name: "Albanian Lek", flag: "🇦🇱", exchangeRate: 1.1, taxRate: 0 },
  { code: "AMD", symbol: "֏", name: "Armenian Dram", flag: "🇦🇲", exchangeRate: 4.8, taxRate: 0 },
  { code: "ARS", symbol: "$", name: "Argentine Peso", flag: "🇦🇷", exchangeRate: 10.5, taxRate: 0 },
  { code: "AUD", symbol: "A$", name: "Australian Dollar", flag: "🇦🇺", exchangeRate: 0.018, taxRate: 10 },
  { code: "AZN", symbol: "₼", name: "Azerbaijani Manat", flag: "🇦🇿", exchangeRate: 0.020, taxRate: 0 },

  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka", flag: "🇧🇩", exchangeRate: 1.3, taxRate: 0 },
  { code: "BGN", symbol: "лв", name: "Bulgarian Lev", flag: "🇧🇬", exchangeRate: 0.022, taxRate: 20 },
  { code: "BHD", symbol: "ب.د", name: "Bahraini Dinar", flag: "🇧🇭", exchangeRate: 0.0046, taxRate: 10 },
  { code: "BRL", symbol: "R$", name: "Brazilian Real", flag: "🇧🇷", exchangeRate: 0.061, taxRate: 0 },
  { code: "BTN", symbol: "Nu.", name: "Bhutanese Ngultrum", flag: "🇧🇹", exchangeRate: 1, taxRate: 0 },

  { code: "CAD", symbol: "C$", name: "Canadian Dollar", flag: "🇨🇦", exchangeRate: 0.017, taxRate: 5 },
  { code: "CHF", symbol: "Fr", name: "Swiss Franc", flag: "🇨🇭", exchangeRate: 0.013, taxRate: 7.7 },
  { code: "CLP", symbol: "$", name: "Chilean Peso", flag: "🇨🇱", exchangeRate: 11.5, taxRate: 0 },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan", flag: "🇨🇳", exchangeRate: 0.087, taxRate: 13 },
  { code: "COP", symbol: "$", name: "Colombian Peso", flag: "🇨🇴", exchangeRate: 48, taxRate: 0 },
  { code: "CZK", symbol: "Kč", name: "Czech Koruna", flag: "🇨🇿", exchangeRate: 0.28, taxRate: 21 },

  { code: "DKK", symbol: "kr", name: "Danish Krone", flag: "🇩🇰", exchangeRate: 0.084, taxRate: 25 },

  { code: "EGP", symbol: "£", name: "Egyptian Pound", flag: "🇪🇬", exchangeRate: 0.38, taxRate: 0 },
  { code: "EUR", symbol: "€", name: "Euro", flag: "🇪🇺", exchangeRate: 0.011, taxRate: 20 },

  { code: "GBP", symbol: "£", name: "British Pound", flag: "🇬🇧", exchangeRate: 0.0095, taxRate: 20 },
  { code: "GEL", symbol: "₾", name: "Georgian Lari", flag: "🇬🇪", exchangeRate: 0.032, taxRate: 0 },

  { code: "HKD", symbol: "$", name: "Hong Kong Dollar", flag: "🇭🇰", exchangeRate: 0.094, taxRate: 0 },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint", flag: "🇭🇺", exchangeRate: 4.3, taxRate: 27 },

  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah", flag: "🇮🇩", exchangeRate: 190, taxRate: 11 },
  { code: "ILS", symbol: "₪", name: "Israeli Shekel", flag: "🇮🇱", exchangeRate: 0.044, taxRate: 18 },
  { code: "INR", symbol: "₹", name: "Indian Rupee", flag: "🇮🇳", exchangeRate: 1, taxRate: 18 },
  { code: "IQD", symbol: "ع.د", name: "Iraqi Dinar", flag: "🇮🇶", exchangeRate: 16, taxRate: 0 },
  { code: "IRR", symbol: "﷼", name: "Iranian Rial", flag: "🇮🇷", exchangeRate: 500, taxRate: 0 },

  { code: "JPY", symbol: "¥", name: "Japanese Yen", flag: "🇯🇵", exchangeRate: 1.8, taxRate: 10 },

  { code: "KES", symbol: "KSh", name: "Kenyan Shilling", flag: "🇰🇪", exchangeRate: 1.9, taxRate: 0 },
  { code: "KRW", symbol: "₩", name: "South Korean Won", flag: "🇰🇷", exchangeRate: 16, taxRate: 10 },
  { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar", flag: "🇰🇼", exchangeRate: 0.0042, taxRate: 5 },

  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee", flag: "🇱🇰", exchangeRate: 3.9, taxRate: 0 },

  { code: "MXN", symbol: "$", name: "Mexican Peso", flag: "🇲🇽", exchangeRate: 0.20, taxRate: 16 },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit", flag: "🇲🇾", exchangeRate: 0.056, taxRate: 6 },

  { code: "NGN", symbol: "₦", name: "Nigerian Naira", flag: "🇳🇬", exchangeRate: 18, taxRate: 0 },
  { code: "NPR", symbol: "Rs", name: "Nepalese Rupee", flag: "🇳🇵", exchangeRate: 1.6, taxRate: 0 },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar", flag: "🇳🇿", exchangeRate: 0.016, taxRate: 15 },

  { code: "OMR", symbol: "ر.ع.", name: "Omani Rial", flag: "🇴🇲", exchangeRate: 0.0042, taxRate: 5 },

  { code: "PHP", symbol: "₱", name: "Philippine Peso", flag: "🇵🇭", exchangeRate: 0.68, taxRate: 12 },
  { code: "PKR", symbol: "Rs", name: "Pakistani Rupee", flag: "🇵🇰", exchangeRate: 3.4, taxRate: 0 },
  { code: "PLN", symbol: "zł", name: "Polish Zloty", flag: "🇵🇱", exchangeRate: 0.052, taxRate: 23 },

  { code: "QAR", symbol: "﷼", name: "Qatari Riyal", flag: "🇶🇦", exchangeRate: 0.044, taxRate: 0 },

  { code: "RON", symbol: "lei", name: "Romanian Leu", flag: "🇷🇴", exchangeRate: 0.055, taxRate: 19 },
  { code: "RUB", symbol: "₽", name: "Russian Ruble", flag: "🇷🇺", exchangeRate: 1.1, taxRate: 0 },

  { code: "SAR", symbol: "﷼", name: "Saudi Riyal", flag: "🇸🇦", exchangeRate: 0.045, taxRate: 15 },
  { code: "SEK", symbol: "kr", name: "Swedish Krona", flag: "🇸🇪", exchangeRate: 0.11, taxRate: 25 },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar", flag: "🇸🇬", exchangeRate: 0.016, taxRate: 9 },
  { code: "THB", symbol: "฿", name: "Thai Baht", flag: "🇹🇭", exchangeRate: 0.42, taxRate: 7 },
  { code: "TRY", symbol: "₺", name: "Turkish Lira", flag: "🇹🇷", exchangeRate: 0.37, taxRate: 20 },

  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia", flag: "🇺🇦", exchangeRate: 0.46, taxRate: 20 },
  { code: "USD", symbol: "$", name: "US Dollar", flag: "🇺🇸", exchangeRate: 0.012, taxRate: 0 },
  { code: "UYU", symbol: "$", name: "Uruguayan Peso", flag: "🇺🇾", exchangeRate: 0.46, taxRate: 0 },

  { code: "VND", symbol: "₫", name: "Vietnamese Dong", flag: "🇻🇳", exchangeRate: 300, taxRate: 10 },
  { code: "ZAR", symbol: "R", name: "South African Rand", flag: "🇿🇦", exchangeRate: 0.23, taxRate: 15 },
];
